<template>
  <v-dialog v-model="dialog" width="544px">
    <v-card>
      <v-card-title>
        {{ isEditing ? $t('profile.team_members_action_edit_user') : $t('profile.team_members_invite_a_new_user') }}
      </v-card-title>
      <div class="mt-5 mx-7">
        <v-form ref="form" v-model="valid">
          <v-text-field
            v-model="name"
            :label="nameLabel"
            :rules="[rules.required, rules.name]"
            required
            outlined
            dense
          />
          <v-text-field
            v-model="email"
            class="mt-2"
            :label="emailLabel"
            :rules="[rules.required, rules.email]"
            required
            outlined
            dense
            :disabled="isEditing"
          />
        </v-form>
      </div>
      <v-card-actions class="pb-5 mx-3">
        <v-spacer />
        <v-btn text color="primary" @click="close">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" class="white--text ml-3 lightened-disabled" :disabled="!valid || isLoading" @click="handleInvite">
          {{ isEditing ? $t('save') : $t('profile.team_members_invite') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'InviteUserDialog',
  props: {
    displayInviteUserDialog: {
      type: Boolean,
      default: false,
      required: true
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    selectedUser: {
      type: Object,
      default: () => null,
      required: false
    }
  },
  data: () => ({
    valid: false,
    name: '',
    email: '',
    isLoading: false
  }),
  computed: {
    dialog: {
      get () {
        return this.displayInviteUserDialog
      },
      set (value) {
        this.$emit('update:displayInviteUserDialog', value)
      }
    },
    rules () {
      return {
        required: v => !!v || this.$t('field_required'),
        email: v => /.+@.+\..+/.test(v) || this.$t('profile.team_members_invalid_email'),
        name: v => (v && v.trim().length > 1) || this.$t('field_required')
      }
    },
    nameLabel () {
      return `${this.$t('profile.team_members_name')}*`
    },
    emailLabel () {
      return `${this.$t('profile.team_members_email')}*`
    }
  },
  methods: {
    close () {
      this.dialog = false
      this.reset()
    },
    reset () {
      this.name = ''
      this.email = ''
      this.valid = false
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
    async handleInvite () {
      try {
        if (!this.valid) return
        this.isLoading = true
        const payload = { email: this.email, role: 'brand_manager' }
        const splitName = this.name.split(' ')

        if (splitName.length > 1) {
          payload.first_name = splitName[0]
          payload.last_name = splitName.slice(1).join(' ')
        } else {
          payload.first_name = this.name
          payload.last_name = ''
        }

        if (this.isEditing) {
          payload.id = this.selectedUser.id
          await this.$store.dispatch('editTeamMemberDetails', payload)
          await this.$store.dispatch('showSnackBar', { message: this.$t('profile.team_members_user_edited') })
        } else {
          await this.$store.dispatch('addTeamMember', payload)
          await this.$store.dispatch('showSnackBar', { message: this.$t('profile.team_members_user_added') })
        }
        this.isLoading = false
        this.close()
      } catch (e) {
        this.isLoading = false
        console.log(e)
      }
    }
  },
  watch: {
    selectedUser: {
      handler (newValue) {
        if (newValue !== null) {
          this.name = newValue.first_name + ' ' + newValue.last_name
          this.email = newValue.email
        } else {
          this.name = ''
          this.email = ''
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style scoped lang="sass">
@import "@/variables.sass"

.theme--light.v-btn--disabled.lightened-disabled
  background-color: rgba($primary, 0.5) !important
  color: white !important
</style>
